export const jewish_ghettos = `
<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
  <circle cx="6" cy="6" r="5.5" fill="#FC443A" stroke="#FC443A"/>
</svg>
`

export const transit_ghettos = `
<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M24.1289 1.6084V24.1289H1.6084V1.6084H24.1289Z" fill="white" stroke="#23201A" stroke-width="3.21714"/>
<circle cx="12.8676" cy="12.8696" r="4.28951" fill="#23201A"/>
</svg>

`

export const extermination_camp = `
<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="1.5" y="1.5" width="22.7371" height="22.7371" fill="white" stroke="#23201A" stroke-width="3"/>
<path d="M16.2023 12.8666L20.3727 17.037L17.0364 20.3733L12.866 16.2029L8.69566 20.3733L5.35938 17.037L9.52974 12.8666L5.35938 8.69627L8.69566 5.35999L12.866 9.53035L17.0364 5.35999L20.3727 8.69627L16.2023 12.8666Z" fill="#23201A"/>
</svg>
`
